<template lang="pug">
  section.section.lifestyle#lifestyle
    SectionTitle(:text="title", :description="description", number="3", isContrast)
    .container.lifestyle__photo-list
      swiper.lifestyle__swiper(
        :options="instaPhotosSwiperOption", 
        ref="myInstaSwiper",
        @init="setPhotoHeight"
      )
        swiper-slide.lifestyle__slide(v-for="photo in photos", :key="photo.key")
          a.lifestyle__link(:href="photo.link", target="_blank", v-fade)
            img.lifestyle__photo(:src="photo.url", :alt="photo.alt", 
            :style="{'height' : `${photoHeight}px`}")
      .insta-swiper-button-next.swiper-button-next
      .insta-swiper-button-prev.swiper-button-prev
</template>

<script>
import SectionTitle from "./SectionTitle.vue";

export default {
  name: "LifeStyle",
  components: {
    SectionTitle
  },
  data() {
    return {
      title: `Жизнь в стиле Villa Blanca`,
      description:
        "Жизнь в стиле Villa Blanca — это наслаждение ее изысканным вкусом во всей палитре красок и оттенков.",
      photos: [],
      photoHeight: "",
      instaPhotosSwiperOption: {
        slidesPerColumnFill: "column",
        spaceBetween: 20,
        navigation: {
          nextEl: ".insta-swiper-button-next",
          prevEl: ".insta-swiper-button-prev"
        },
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >=
          0: {
            slidesPerView: 1,
            slidesPerColumn: 1
          },
          576: {
            slidesPerView: 2,
            slidesPerColumn: 1
          },
          992: {
            slidesPerView: 3,
            slidesPerColumn: 2
          }
        }
      }
    };
  },
  methods: {
    setPhotoHeight() {
      if (window.innerWidth >= 1200) {
        setTimeout(() => {
          this.photoHeight = document.querySelector(
            ".lifestyle__slide"
          ).offsetHeight;
        }, 500);
      }
    }
  },
  mounted() {
    var self = this;
    var token = "17094210473.8cc5e65.c966c0b6b8d2487fb64b4378cdd0d19b";
    var numPhotos = 20; // maximum 20;

    window.addPhotosToArray = function(data) {
      let photoHeightArray = [];

      for (let i = 0; i < data.data.length; i++) {
        let dataItem = data.data[i];

        let photo = {
          url: dataItem.images.standard_resolution.url,
          alt: "",
          link: "",
          key: dataItem.id
        };

        photoHeightArray.push(dataItem.images.standard_resolution.height);

        if (dataItem.caption) {
          photo.alt = dataItem.caption.text;
        } else {
          photo.alt = "Villa Blanca Instagram";
        }
        photo.link = dataItem.link;

        if (dataItem.carousel_media) {
          for (let index = 0; index < dataItem.carousel_media.length; index++) {
            if (dataItem.carousel_media[index].images) {
              let carouselPhoto = {
                url:
                  dataItem.carousel_media[index].images.standard_resolution.url,
                alt: photo.alt,
                link: photo.link,
                key: photo.key + index
              };

              photoHeightArray.push(
                dataItem.carousel_media[index].images.standard_resolution.height
              );
              self.photos.push(carouselPhoto);
            }
          }
        } else {
          self.photos.push(photo);
        }
      }
    };

    const scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = `https://api.instagram.com/v1/users/self/media/recent?access_token=${token}&count=${numPhotos}&callback=addPhotosToArray`;
    })
      .then(result => self.setPhotoHeight())
      .catch(error => console.log(error));
  }
};
</script>


<style lang="scss">
@import "../styles/main.scss";

.lifestyle {
  &__photo-list {
    margin-top: 49px;
    position: relative;
  }
  &__link {
    display: block;
    width: 100%;
    overflow: hidden;
  }
  &__photo {
    width: 100%;
    height: auto;

    @include from("xl") {
      width: auto;
    }
  }
  &__swiper {
    width: 100%;

    @include from("xl") {
      height: 824px;
    }

    @include from("xxxl") {
      height: auto;
    }

    .swiper-slide {
      width: 100%;
      height: auto;
      overflow: hidden;

      @include from("xl") {
        height: 404px;
      }

      @include from("xxxl") {
        height: auto;
      }
    }
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 23px;
    height: 57px;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
  .swiper-button-next {
    background-image: url("~@/assets/slider-next--dark.svg");

    @include from("lg") {
      right: -50px;
    }
  }
  .swiper-button-prev {
    background-image: url("~@/assets/slider-prev--dark.svg");

    @include from("lg") {
      left: -50px;
    }
  }
}
</style>